'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(props) {
    return _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        _react2.default.createElement(
            'svg',
            {
                height: props.height,
                width: props.width,
                version: '1.1',
                viewBox: '0 0 22 28',
                xmlns: 'http://www.w3.org/2000/svg'
            },
            _react2.default.createElement('path', {
                d: 'M14.523 21.808c0 .347.049.683.149 1.006.1.324.251.611.451.86.2.25.445.449.735.599.289.15.628.226 1.017.226.413 0 .762-.076 1.052-.226.29-.15.526-.35.71-.598.183-.25.316-.537.4-.861.084-.323.124-.659.124-1.006V20.45a3.54 3.54 0 0 0-.141-1.005 2.419 2.419 0 0 0-.434-.852 2.249 2.249 0 0 0-.725-.59c-.29-.152-.63-.225-1.019-.225-.389 0-.732.073-1.026.224a2.154 2.154 0 0 0-.727.591c-.19.243-.332.527-.426.852a3.57 3.57 0 0 0-.14 1.005v1.357zm-2.84-1.357c0-.705.115-1.377.344-2.015a4.662 4.662 0 0 1 1.01-1.657 4.94 4.94 0 0 1 1.619-1.121c.633-.278 1.363-.417 2.186-.417s1.554.139 2.195.417c.64.278 1.179.653 1.619 1.12a4.74 4.74 0 0 1 1.002 1.658c.227.638.342 1.31.342 2.015v1.357c0 .717-.115 1.39-.342 2.015a4.946 4.946 0 0 1-.993 1.65 4.593 4.593 0 0 1-1.612 1.12c-.64.27-1.365.407-2.178.407-.822 0-1.557-.136-2.203-.407a4.735 4.735 0 0 1-1.635-1.12 4.766 4.766 0 0 1-1.01-1.65 5.836 5.836 0 0 1-.344-2.015V20.45zM6.01 24.76l-2.085-1.25L15.79 3.743l2.086 1.25L6.009 24.76zM2.84 7.565c0 .348.047.684.141 1.008.094.323.24.607.434.851.195.243.437.44.725.59.291.151.637.226 1.037.226.39 0 .728-.075 1.017-.226.29-.15.528-.347.719-.59.188-.244.33-.528.425-.851.095-.324.14-.66.14-1.008V6.228c0-.348-.045-.683-.14-1.007a2.517 2.517 0 0 0-.434-.86 2.197 2.197 0 0 0-.726-.6c-.29-.15-.635-.225-1.036-.225-.389 0-.729.075-1.018.225-.289.151-.528.351-.717.6-.19.249-.332.536-.426.86-.094.324-.14.66-.14 1.007v1.337zM0 6.228c0-.718.115-1.393.343-2.024a4.821 4.821 0 0 1 1.001-1.658c.44-.475.98-.85 1.62-1.13C3.604 1.14 4.33 1 5.141 1c.836 0 1.572.139 2.211.417.641.278 1.178.654 1.612 1.13.434.474.765 1.027.993 1.657.227.631.342 1.306.342 2.024v1.337c0 .706-.115 1.375-.342 2.006a4.786 4.786 0 0 1-.993 1.65 4.73 4.73 0 0 1-1.602 1.12c-.635.278-1.363.417-2.186.417-.824 0-1.556-.139-2.196-.417a4.875 4.875 0 0 1-1.627-1.12 4.64 4.64 0 0 1-1.01-1.65A5.855 5.855 0 0 1 0 7.565V6.228z',
                fill: props.fill,
                fillRule: 'evenodd',
                stroke: 'none',
                strokeWidth: '1'
            })
        )
    );
};

Icon.propTypes = {
    fill: _propTypes2.default.string,
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Icon.defaultProps = {
    fill: '#FFF',
    width: '22px',
    height: '28px'
};

Icon.displayName = 'ProductDepositWhite';

exports.default = Icon;